import {useListView} from '../../core/ListViewProvider'
import {PaymentsListToolbar} from './PaymentListToolbar'
import {PaymentsListGrouping} from './PaymentsListGrouping'
import {PaymentsListSearchComponent} from './PaymentsListSearchComponent'

const PaymentsListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <PaymentsListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <PaymentsListGrouping /> : <PaymentsListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {PaymentsListHeader}
